import React, { FunctionComponent } from 'react';
import MessageEvent from '$/components/Socket/MessageEvent';

import { withWebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { AttendeeCounterOption, RoomType, SocketNotification } from '$/GraphQL/schema/schema';
import { Trans } from '@lingui/macro';

const ViewerCount: FunctionComponent = withWebinarPlayerContext([
  'ewebinar',
  'currentRoom',
  'attendeeCount',
  'setAttendeeCount',
])(({ context }) => {
  const { ewebinar, currentRoom, attendeeCount, setAttendeeCount } = context;
  const onMessage = React.useCallback(
    (notification: SocketNotification): void => {
      if (notification.attendeeLiveUpdate) {
        setAttendeeCount(notification.attendeeLiveUpdate.inSession);
      }
    },
    [setAttendeeCount]
  );

  if (
    !ewebinar ||
    !currentRoom.caps.inSession ||
    currentRoom.type === RoomType.Exit ||
    !ewebinar.viewerRoomSettings.attendeeCounter
  ) {
    return null;
  }

  const showingPastViews =
    ewebinar.viewerRoomSettings.attendeeCounterOption === AttendeeCounterOption.Attended;

  if (attendeeCount === 0) return null;

  return (
    <span>
      <MessageEvent handler={onMessage} />

      <span className='mx-1/2e'>{' | '}</span>
      {showingPastViews ? (
        <Trans>{attendeeCount} Viewed</Trans>
      ) : (
        <Trans>{attendeeCount} Viewing</Trans>
      )}
    </span>
  );
});

export default ViewerCount;
